import { CompanyActionTypes } from './types';
import { CompanyStateI, companyInitialState } from './state';

export const companyReducer = (state = companyInitialState, action: any): CompanyStateI => {
  switch (action.type) {
    case CompanyActionTypes.LOAD_STATE:
      return {
        ...state,
        ...action.payload, // Merge stored state with initial state
      };
    case CompanyActionTypes.SET_LOCATIONS:
      return {
        ...state,
        locations: action.payload,
      };
    case CompanyActionTypes.SET_USERS:
      return {
        ...state,
        users: action.payload,
      };
    case CompanyActionTypes.SET_CLIENTS:
      return {
        ...state,
        clients: action.payload,
      };
    case CompanyActionTypes.SET_RATINGS:
      return {
        ...state,
        ratings: action.payload,
      };
    case CompanyActionTypes.SET_CAREPARTNERS:
      return {
        ...state,
        carePartners: action.payload,
      };
    case CompanyActionTypes.SET_CARE_MANAGER_ACTIVITIES:
      return {
        ...state,
        careManagerActivities: action.payload,
      };
    case CompanyActionTypes.SET_APPLICANTS:
      return {
        ...state,
        applicants: action.payload,
      };
    case CompanyActionTypes.SET_AWARD_TYPES:
      return {
        ...state,
        awardTypes: action.payload,
      };
    case CompanyActionTypes.SET_DEACTIVATION_REASONS:
      return {
        ...state,
        deactivationReasons: action.payload,
      };
    case CompanyActionTypes.SET_LOST_CLIENT_REASONS:
      return {
        ...state,
        lostClientReasons: action.payload,
      };
    case CompanyActionTypes.SET_APPLICANT_STAGES:
      return {
        ...state,
        applicantStages: action.payload,
      };
    case CompanyActionTypes.SET_REFERRAL_PARTNERS:
      return {
        ...state,
        referralPartner: action.payload,
      };
    case CompanyActionTypes.RESET:
      return { ...companyInitialState };
    case CompanyActionTypes.SET_COMPANIES:
      return {
        ...state,
        companies: action.payload,
      };
    case CompanyActionTypes.SET_PROSPECT:
      return {
        ...state,
        prospect: action.payload,
      };
    case CompanyActionTypes.SET_COMPANY_RATINGS:
      return {
        ...state,
        companyRatings: action.payload,
      };
    case CompanyActionTypes.SET_MILESTONES:
      return {
        ...state,
        milestones: action.payload,
      };

      case CompanyActionTypes.SET_ACTIVITY_TYPES:
      return {
        ...state,
        activityTypes: action.payload,
      };
    case CompanyActionTypes.SET_ACTIVITY_TYPES:
      return {
        ...state,
        activityTypes: action.payload,
      };
      case CompanyActionTypes.SET_APPLICANT_ACTIVITY:
      return {
        ...state,
        applicantsActivity: action.payload,
      };
    case CompanyActionTypes.SET_COMPANY_TYPES:
      return {
        ...state,
        companyTypes: action.payload,
      };
      case CompanyActionTypes.SET_LEAD_SOURCES:
      return {  
        ...state,
        leadSources: action.payload,
      };
      case CompanyActionTypes.SET_REFERRAL_ACTIVITY_TYPES:
      return {  
        ...state,
        referralActivityTypes: action.payload,
      };
    default:
      return { ...state };
  }
};
